import { render } from "./SupersededBy.vue?vue&type=template&id=097a1868"
import script from "./SupersededBy.vue?vue&type=script&lang=js"
export * from "./SupersededBy.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__